import z from "zod";

/**
 * EntregaObraClienteOcorrenciaSchema
 */

export const EntregaObraClienteOcorrenciaSchema = z.object({

  idEntregaObraCliente: z.number().optional(),
  idVerificacaoChecklist: z.number().nullable().default(null),
  inspecao: z.coerce.number().nullable().default(null),
  dataDescricao: z.coerce.date().nullable().default(null),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),
  dataTratativa: z.coerce.date().nullable().default(null),
  tratativa: z.string().nullable().default(null),

  descricaoArquivo: z.string().nullable().default(null),
  arquivo: z.instanceof(File).nullable().default(null),
  nomeArquivo: z.string().nullable().default(null),
  limparArquivo: z.boolean().optional().default(false),

  descricaoArquivo2: z.string().nullable().default(null),
  arquivo2: z.instanceof(File).nullable().default(null),
  nomeArquivo2: z.string().nullable().default(null),
  limparArquivo2: z.boolean().optional().default(false),

});



/**
 * EntregaObraClienteOcorrenciaForm
 */

export type EntregaObraClienteOcorrenciaForm = z.infer<typeof EntregaObraClienteOcorrenciaSchema>;